import { render, staticRenderFns } from "./homeTop.vue?vue&type=template&id=2b716f3b"
import script from "./homeTop.vue?vue&type=script&lang=js"
export * from "./homeTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports